export const CLEAR_COSTS = {
  REQUEST: 'CustomServiceRequests/ClearCosts/Request',
  SUCCESS: 'CustomServiceRequests/ClearCosts/Success',
  FAILURE: 'CustomServiceRequests/ClearCosts/Failure'
};

export const FORSUBMIT = {
  REQUEST: 'CustomServiceRequests/ForSubmit/Request',
  SUCCESS: 'CustomServiceRequests/ForSubmit/Success',
  FAILURE: 'CustomServiceRequests/ForSubmit/Failure'
};

export const CREATE = {
  REQUEST: 'CustomServiceRequests/Create/Request',
  SUCCESS: 'CustomServiceRequests/Create/Success',
  FAILURE: 'CustomServiceRequests/Create/Failure'
};

export const UPDATE = {
  REQUEST: 'CustomServiceRequests/Update/Request',
  SUCCESS: 'CustomServiceRequests/Update/Success',
  FAILURE: 'CustomServiceRequests/Update/Failure'
};

export const REMOVE = {
  REQUEST: 'CustomServiceRequests/Remove/Request',
  SUCCESS: 'CustomServiceRequests/Remove/Success',
  FAILURE: 'CustomServiceRequests/Remove/Failure'
};
